import { useDislikedJobsContext } from '../../context/DislikedJobsContext';

import { useMemo } from 'react';

export const useJobDislikeActions = (jobKey: string, dislikeJobPageId: string, tk?: string) => {
    const {
        dislikedJobs,
        dislikeJob: disklikeJobCallback,
        undoDislikeJob: undoDislikeJobCallback,
    } = useDislikedJobsContext();

    const isDislikedJob = useMemo(() => dislikedJobs.has(jobKey), [dislikedJobs, jobKey]);

    const dislikeJob = () => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- FIXME
        disklikeJobCallback(jobKey, dislikeJobPageId, tk);
    };
    const undoDislikeJob = () => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- FIXME
        undoDislikeJobCallback(jobKey, dislikeJobPageId, tk);
    };

    return { isDislikedJob, dislikeJob, undoDislikeJob };
};
